import routes from '../routes/Services.routes';
import axios from 'axios';

export default async function addCouncellingApi(body){
    return await axios.post(routes.AddCouncelling, body).then(res=>{
        return res.data;
    }).catch(error =>{
        if(error.response){
            return error.response.data.message;
        }else if(error.request){           
        }else{
        }
    })
}